import z from "zod";
import { RegionSchema } from "@/api/williams/region";
import { UserSchema } from "../users";
import { Welder } from "@/api/williams/welders";

const REQUIRED_FIELD_ERROR = "Required Field";

export const WelderSchema = z
  .object({
    welderId: z.string(),
    welderVersionId: z.string(),
    name: z.string().trim().nullish(),
    firstName: z.string().trim().nonempty(REQUIRED_FIELD_ERROR),
    lastName: z.string().trim().nonempty(REQUIRED_FIELD_ERROR),
    badgeNumber: z.string().nullish(),
    stampNumber: z.string().nullish(),
    companyId: z.string().nullish(),
    ssn: z.string().nonempty(REQUIRED_FIELD_ERROR),
    emailAddress: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    weldingSpecialist: UserSchema.nullish(),
    shopField: z.string().nullish(),
    regions: z.array(RegionSchema).nullish(),
    advisories: z.array(z.string()).nullish(),
  })
  .transform((data) => data as Welder);
